const statusNames = {
  AVAILABLE_PACKAGES: 'availablePackages',
  ECOMMERCE_PACKAGES: 'ecommercePackages',
};

export default statusNames;
